import Constants from '../definitions/constants';
import { intl } from '../locales/localesConfig';

const FormatTooling = {
  defaultsTextFormatTypes: (value, dataType, addSeconds = false) => {
    let timeFormatOptions = !addSeconds ? { hour: 'numeric', minute: 'numeric' } : { hour: 'numeric', minute: 'numeric', second: 'numeric' };
    if(value==null || typeof value === "undefined") {
      return "";
    }
    switch (dataType) {
      case Constants.crudGenerator.dataTypes.TEXT:
        return value;
      case Constants.crudGenerator.dataTypes.BOOLEAN:
        return value ? 
          intl.formatMessage({ id: "common.dataTypes.boolean.yes" }) : 
          intl.formatMessage({ id: "common.dataTypes.boolean.no" });
      case Constants.crudGenerator.dataTypes.DATETIME:
        return intl.formatDate(new Date(value)) + " " + intl.formatTime(new Date(value), timeFormatOptions);
      case Constants.crudGenerator.dataTypes.DATE:
        if(value.length==10) {
          return intl.formatDate(new Date(value + " 12:00:00"));
        }
        return intl.formatDate(new Date(value));
      case Constants.crudGenerator.dataTypes.TIME:
        return intl.formatTime(new Date(value), timeFormatOptions);
      case Constants.crudGenerator.dataTypes.NUMBER:
        let numberFormater = new Intl.NumberFormat('en-US', {maximumFractionDigits:2});
        return isNaN(value) ? value : numberFormater.format(value);
      case Constants.crudGenerator.dataTypes.NUMBER_ALL_DECIMALS:
        let numberFormater2 = new Intl.NumberFormat('en-US', {maximumFractionDigits:20});
        return isNaN(value) ? value : numberFormater2.format(value);        
      default:
        return value;
    }
  },
  metricDatasFormatTypes: (value, dataType) => {
    if(value==null || value=="" || typeof value === "undefined") {
      return "";
    }    
    let numberFormater = null;
    switch (dataType) {
      case Constants.selectKeys.metric.dataType.NUMBER:
        numberFormater = new Intl.NumberFormat('en-US', {maximumFractionDigits:2});
        return isNaN(value) ? value : numberFormater.format(value);
      case Constants.selectKeys.metric.dataType.PERCENTAGE:
        numberFormater = new Intl.NumberFormat('en-US', {style: "percent", maximumFractionDigits:2});
        return isNaN(value) ? value : numberFormater.format(value);
      default:
        return value;
    }
  },
  getMetricDatasFormatTypeFunction: (dataType) => {
    return (value) => {
      return FormatTooling.metricDatasFormatTypes(value, dataType)
    }    
  },
  toUpperCaseFirst: (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  preventTexboxZeroHide: (number) => {
    if(number==0) {
      return number+"";
    }
    return number;
  },
  zeroPadding: (number, length) => {
    return (Array(length).join('0') + number).slice(-length);
  },
  hexCodeColorToRGB: (hexCode) => {
    if(hexCode==null || hexCode=="") {
      return "";
    }
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexCode);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  },
  escapeHTML: (str) => {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }
};

export default FormatTooling;


// WEBPACK FOOTER //
// ./source/tooling/formatTooling.js